import React from "react";

import * as jsPDF from "jspdf";
import "jspdf-autotable";



const TITLE_FONT_SIZE = 36;
const HEADER_FONT_SIZE = 24;
const TIMESTAMP_FONT_SIZE = 11;
const TEXT_FONT_SIZE = 14;

export default class Report extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show_modal: false,
            project_name: "",
            evaluator_name: "",
            project_comments: "",
        };
    }

    toggle_modal(show_modal) {
        this.setState({
            show_modal: show_modal,
        });
    }

    update_input_value(variable_name) {
        return event => {
            let update_dict = {};
            update_dict[variable_name] = event.target.value;
            this.setState(update_dict);
        };
    }

    render_modal() {
        return (
            <div
                className={
                    "modal" + (this.state.show_modal ? " is-active" : "")
                }
            >
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">
                            Export Bitrapy Report
                        </p>
                        <button
                            className="delete"
                            aria-label="close"
                            onClick={() => this.toggle_modal(false)}
                        ></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="field">
                            <label className="label">
                                Project Name
                                <span className="has-text-danger"> *</span>
                            </label>
                            <div className="control">
                                <input
                                    className="input"
                                    type="text"
                                    placeholder="e.g Alpha Go"
                                    value={this.state.project_name}
                                    onChange={this.update_input_value(
                                        "project_name"
                                    )}
                                />
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">
                                Evaluator Name
                                <span className="has-text-danger"> *</span>
                            </label>
                            <div className="control">
                                <input
                                    className="input"
                                    type="text"
                                    placeholder="e.g. Lee Sedol"
                                    value={this.state.evaluator_name}
                                    onChange={this.update_input_value(
                                        "evaluator_name"
                                    )}
                                />
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Comments</label>
                            <div className="control">
                                <textarea
                                    className="textarea has-fixed-size"
                                    placeholder="e.g. AlphaGo is a computer program that plays the board game Go."
                                    value={this.state.project_comments}
                                    onChange={this.update_input_value(
                                        "project_comments"
                                    )}
                                ></textarea>
                            </div>
                            <p className="help">
                                <span className="has-text-danger">*</span>{" "}
                                indicates required fields
                            </p>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <button
                            className="button is-primary"
                            onClick={this.create.bind(this)}
                            disabled={
                                !this.state.project_name ||
                                !this.state.evaluator_name
                            }
                        >
                            <span className="icon is-medium has-text-white">
                                <i className="fas fa-file-download"></i>
                            </span>
                            <span>Download</span>
                        </button>
                        <button
                            className="button"
                            onClick={() => this.toggle_modal(false)}
                        >
                            Cancel
                        </button>
                    </footer>
                </div>
            </div>
        );
    }

    add_title(doc) {
        doc.setFontSize(TITLE_FONT_SIZE);
        doc.text("Bitrapy Report", 15, 25);
    }

    add_project_details(doc) {
        doc.setFontSize(TEXT_FONT_SIZE);

        doc.autoTable({
            theme: "grid",
            margin: { left: 15 },
            startY: 50,
            columnStyles: {
                0: {
                    cellWidth: 30,
                },
                1: {
                    fontStyle: "bold",
                },
            },
            body: [
                ["Project Name", this.state.project_name],
                ["Evaluator Name", this.state.evaluator_name],
                ["Comments", this.state.project_comments],
            ],
        });
    }

    add_timestamp(doc) {
        const timestamp = new Date();
        const timestampISOFormat = timestamp.toISOString();
        const timestampReadableFormat = timestamp.toLocaleString("en-GB");
        doc.setFontSize(TIMESTAMP_FONT_SIZE);
        doc.text("Created on: " + timestampReadableFormat, 17, 35);
        return timestampISOFormat;
    }

    add_scores(doc) {
        doc.setFontSize(HEADER_FONT_SIZE);
        doc.text(
            "Bitrapy Score: " +
                this.props.calculate_score(null, null, this.props.questions) +
                "%",
            17,
            95
        );

        doc.text("Metrics,", 15, 120);
        doc.setFontSize(TEXT_FONT_SIZE);

        doc.autoTable({
            theme: "grid",
            margin: { left: 20 },
            startY: 130,
            columnStyles: {
                0: {
                    cellWidth: 30,
                },
                1: {
                    fontStyle: "bold",
                    cellWidth: 15,
                    halign: "right",
                },
            },
            body: [
                [
                    "Transparency",
                    this.props.calculate_score(
                        "transparency",
                        null,
                        this.props.questions
                    ) + "%",
                ],
                [
                    "Privacy",
                    this.props.calculate_score(
                        "privacy",
                        null,
                        this.props.questions
                    ) + "%",
                ],
                [
                    "Bias",
                    this.props.calculate_score(
                        "bias",
                        null,
                        this.props.questions
                    ) + "%",
                ],
            ],
        });

        doc.setFontSize(HEADER_FONT_SIZE);
        doc.text("Components,", 15, 185);
        doc.setFontSize(TEXT_FONT_SIZE);

        doc.autoTable({
            theme: "grid",
            margin: { left: 20 },
            startY: 195,
            headStyles: { halign: "center", fillColor: [67, 125, 181] },
            columnStyles: {
                1: {
                    fontStyle: "bold",
                    halign: "center",
                },
                2: {
                    fontStyle: "bold",
                    halign: "center",
                },
                3: {
                    fontStyle: "bold",
                    halign: "center",
                },
                4: {
                    fontStyle: "bold",
                    halign: "center",
                },
                5: {
                    fontStyle: "bold",
                    halign: "center",
                },
            },
            head: [
                [
                    "Component",
                    "Bitrapy",
                    "Transparency",
                    "Privacy",
                    "Bias",
                ],
            ],
            body: [
                [
                    "Conceptualization",
                    this.props.calculate_score(
                        null,
                        "conceptualization",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "transparency",
                        "conceptualization",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "privacy",
                        "conceptualization",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "bias",
                        "conceptualization",
                        this.props.questions
                    ) + "%",
                ],
                [
                    "Prototyping",
                    this.props.calculate_score(
                        null,
                        "prototyping",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "transparency",
                        "prototyping",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "privacy",
                        "prototyping",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "bias",
                        "prototyping",
                        this.props.questions
                    ) + "%",
                ],
                [
                    "Testing",
                    this.props.calculate_score(
                        null,
                        "testing",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "transparency",
                        "testing",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "privacy",
                        "testing",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "bias",
                        "testing",
                        this.props.questions
                    ) + "%",
                ],
                [
                    "Deployment",
                    this.props.calculate_score(
                        null,
                        "deployment",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "transparency",
                        "deployment",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "privacy",
                        "deployment",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "bias",
                        "deployment",
                        this.props.questions
                    ) + "%",
                ],
                [
                    "Maturity&Feedback",
                    this.props.calculate_score(
                        null,
                        "maturity&feedback",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "transparency",
                        "maturity&feedback",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "privacy",
                        "maturity&feedback",
                        this.props.questions
                    ) + "%",
                    this.props.calculate_score(
                        "bias",
                        "maturity&feedback",
                        this.props.questions
                    ) + "%",
                ],
            ],
        });
    }

    add_answer_summary(doc, component, x, y) {
        doc.setFontSize(TEXT_FONT_SIZE);
        doc.text(
            "Answered " +
                this.props.questions.filter(
                    question =>
                        (question.component === component ||
                            component === null) &&
                        question.answer !== this.props.no_answer
                ).length +
                " of " +
                this.props.questions.filter(
                    question =>
                        question.component === component || component === null
                ).length +
                " questions.",
            x,
            y
        );
    }

    add_component_questions(doc, questions, component, component_name) {
        doc.addPage();
        doc.setFontSize(HEADER_FONT_SIZE);
        doc.text(component_name, 15, 20);
        doc.setFontSize(TEXT_FONT_SIZE);
        this.add_answer_summary(doc, component, 17, 35);
        let question_table = [];
        questions
            .filter(question => {
                // console.log(question.component + " "+component)
                return question.component === component;
            })
            .map(question => {
                question_table.push([
                    question.question,
                    this.props.answer_key[question.answer],
                ]);
                return question;
            });
        const question_table_headers = [["Question", "Answer"]];
        doc.autoTable({
            margin: { top: 40, left: 15 },
            head: question_table_headers,
            body: question_table,
        });
    }

    add_questions(doc, questions) {
        this.add_component_questions(doc, questions, "conceptualization", "Conceptualization");
        this.add_component_questions(doc, questions, "prototyping", "Prototyping");
        this.add_component_questions(doc, questions, "testing", "Testing");
        this.add_component_questions(doc, questions, "deployment", "Deployment");
        this.add_component_questions(doc, questions, "maturity&feedback", "Maturity&Feedback");
    }

    create() {
        const doc = new jsPDF();
        this.add_title(doc);
        const timestamp = this.add_timestamp(doc);
        // this.add_project_details(doc);
        this.add_scores(doc);
        this.add_answer_summary(doc, null, 17, 250);
        this.add_questions(doc, this.props.questions);
        doc.save("Bitrapy Report" + timestamp + ".pdf");
        // this.toggle_modal(false);
    }

    render() {
        return (
            
            <div className="level-item download-report-interaction">
                
                <div
                    className="round-interaction"
                    onClick={this.create.bind(this)}
                >
                    <div>
                        <p className="heading">Download</p>
                        <p className="title">
                            <span className="icon">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAAB+CAMAAADV/VW6AAAAZlBMVEX///8AAAD19fX5+fnx8fFBQUH8/PxaWlp5eXlPT0/l5eU+Pj7h4eGFhYVfX1/o6Oja2totLS3Ly8vExMS+vr4ICAgaGhpxcXFlZWUfHx8TExOenp6tra2Xl5eLi4tsbGw3NzdISEib0KjGAAACbUlEQVRoge2a63KbMBBGxR0HsC1iHIMdX97/JQu4aZlEMtqLYNrZ89uTk08rxLKgFJzAAuJPYRC96EUvetGLXvSiF73oRS960Yte9KIX/b+gj02kNr3x1zFBf9HJTx42veG3if6kxP+0qVypUopeVTT7B82u1JViz4lymj+P6HqVY+1bBrlC52fJPvCBsWdcdtT+v7HJlYrA9T9RTruf3GB2xpUfgeVnzj6wdbc/QnY74Prf+rCr8ORm3+x82JVKnfwbL9kHYof9n3nKPpBu5uyaf89PCGfy+6r7F/HL/PrNr70/fzK7vfCcfWBn9Relf3tf/8RsbxfIPmDOv0z2gVgb9IvZTfvf/56f8vat/u1+SXuf/z61Nwuu/JPyMVn5hbMP7Lo/+hXsff2Lder+RdmO+node59fr7XyT/a6WS376F/VLgjC/07kCHWUaCK9OA84Nmf2zutg6a7NtFfe4Qp4tPdgbL8ix8HClI7vZoQaq7Zcj9oXjD0ItjxXwO4+rzLyzqJHv9G4c9hjrD0IDgx6wuschtFqibdzxEe/yxhIqPY9xR4EF6Ie9SLjLwWt+sTw1Oq/mKI5xqdMeGuqnVb9gq5v8PYD3U6IH83Or11IsDde5I32O2ekHtTe2dFIfcOjDzB9b9+tM6VvIwU++6IqVCXxxH2S1SqsoP78Ov4TURySiKNRXAE/Yygbhu8eJmE6WNt/5moUR96hV19/4Bzzmrjyv9e/zo/9cx9I381vKRhHkJ7bDvygS/SiF/0KevZjpwPpWbq8KRlIz9LjToE97WBmWa84AfsNt49kXLnBp0x1rll6zUbn9hHfLys5I6LCYzNHAAAAAElFTkSuQmCC" width="50%" height="50%"></img>
                            </span>
                        </p>
                    </div>
                </div>

                {this.render_modal()}
            </div>
        );
    }
}
